import React from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';
import { mockData } from '../mock';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="lg:col-span-2">
            {/* ▼ ロゴ見出し＋タグライン（追加） */}
            <div className="mb-4">
              <h2 className="text-white tracking-tight text-[1.4rem] sm:text-[1.5rem] leading-[2rem]">
                <span className="font-sans font-extrabold">株式会社</span>
                <span className="ml-2 font-orbitron font-bold tracking-tight">4D Pocket</span>
              </h2>

              <p className="mt-2 text-gray-200 text-[1.05rem] sm:text-[1.1rem] leading-[1.8rem]">
                3D制作と3D運用を、ひとつのポケットで。
              </p>

              <p className="mt-3 text-gray-400 text-[0.95rem] sm:text-[1rem] leading-[1.7rem]">
                {mockData.company.name}は、3Dモックアップ制作のプロフェッショナル集団です。<br/>
                EC事業者様の商品画像制作を、高品質・低コスト・短納期でサポートします。
              </p>
            </div>

            <div className="space-y-3">
              <div className="flex items-center gap-3">
                <Mail className="w-5 h-5 text-green-400" />
                <span className="text-gray-300">info@four-dp.com</span>
              </div>
              <div className="flex items-center gap-3">
                <MapPin className="w-5 h-5 text-green-400" />
                <span className="text-gray-300">東京都中央区銀座1-12-4</span>
              </div>
            </div>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-bold mb-6">サービス</h3>
            <ul className="space-y-3">
              <li>
                <a href="#service" className="text-gray-300 hover:text-blue-400 transition-colors">
                  3Dモックアップ制作
                </a>
              </li>
              <li>
                <a href="#case-study" className="text-gray-300 hover:text-blue-400 transition-colors">
                  制作事例
                </a>
              </li>
              <li>
                <a href="#process" className="text-gray-300 hover:text-blue-400 transition-colors">
                  制作の流れ
                </a>
              </li>
              <li>
                <a href="#faq" className="text-gray-300 hover:text-blue-400 transition-colors">
                  よくある質問
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-12 pt-8 text-center">
          <p className="text-gray-400">
            運営会社：
            <a 
              href="https://official.four-dp.com/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-green-400 hover:text-blue-400 transition-colors"
            >
              {mockData.company.name}
            </a>.<br/>
            ©2025 3Dモックアップサービス All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;